export const videos = [
  {
    id: "v001",
    title: "长夜将明",
    category: "movie",
    year: 2024,
    region: "内地",
    rating: 8.9,
    heat: 9820,
    genre: ["悬疑", "犯罪"],
    actors: ["张译文", "谭卓然", "李承泽"],
    director: "陈默",
    duration: "128 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-10-12",
    cover:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20noir%20poster%20artwork%2C%20a%20lone%20detective%20in%20dark%20coat%20standing%20in%20a%20rain%20soaked%20neon%20lit%20alley%20at%20midnight%2C%20deep%20navy%20shadows%20with%20warm%20amber%20street%20lamp%20glow%2C%2035mm%20film%20grain%2C%20dramatic%20contrast%2C%20moody%20atmospheric%20composition%2C%20no%20text&width=400&height=600&seq=tangdou-v001&orientation=portrait",
    tagline: "一桩沉寂十二年的旧案，在雨夜被重新翻开。",
    description:
      "刑侦队长周野接手一桩早已结案的失踪案，唯一的线索是一段被剪碎的监控录像。随着调查深入，小城表面的平静被一层层揭开，每个人都在为十二年前的那个夜晚保守秘密。剧集以克制冷峻的镜头语言，讲述一个关于真相与代价的故事。",
  },
  {
    id: "v002",
    title: "山海之间",
    category: "movie",
    year: 2023,
    region: "内地",
    rating: 8.6,
    heat: 7640,
    genre: ["剧情", "家庭"],
    actors: ["王砚春", "林豆豆", "郑秋月"],
    director: "沈南",
    duration: "116 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-09-28",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20rustic%20coastal%20village%20at%20golden%20dusk%2C%20father%20and%20daughter%20walking%20along%20a%20stone%20seawall%2C%20fishing%20boats%20and%20layered%20mountains%20in%20mist%2C%20soft%20amber%20sunset%20light%20over%20deep%20blue%20sea%2C%20cinematic%20realistic%20drama%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v002&orientation=portrait",
    tagline: "父亲的渔船停在岸边，女儿的行李箱却已经拉好。",
    description:
      "在南方一个即将整体搬迁的海边渔村，退休渔民老陈决定最后一次出海。为此，在外地工作多年的女儿带着行李回到家中。两个人一间老屋，三天时间，说不出口的歉意和牵挂，都被海风吹得又咸又软。",
  },
  {
    id: "v003",
    title: "银色回声",
    category: "movie",
    year: 2025,
    region: "欧美",
    rating: 8.4,
    heat: 8930,
    genre: ["科幻", "惊悚"],
    actors: ["Elena Ford", "Marcus Vale", "Noah Reed"],
    director: "Adrian Cole",
    duration: "134 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-10-08",
    cover:
      "https://readdy.ai/api/search-image?query=Futuristic%20astronaut%20standing%20inside%20a%20vast%20abandoned%20space%20station%20corridor%2C%20cold%20silver%20metallic%20surfaces%20with%20warm%20amber%20emergency%20lights%2C%20subtle%20lens%20flare%2C%20cinematic%20science%20fiction%20film%20still%2C%20ultra%20detailed%2C%20no%20text&width=400&height=600&seq=tangdou-v003&orientation=portrait",
    tagline: "在距离地球四光年的舱室里，有人回应了她的呼叫。",
    description:
      "深空探测器回传的信号出现异常重复，工程师艾拉被派往废弃的中继站排查。空旷的舱道里，她听到了一段不属于任何记录的声音。当回声开始模仿她的呼吸，她意识到自己并不是这座空间站里唯一的听众。",
  },
  {
    id: "v004",
    title: "最后一个夏天",
    category: "movie",
    year: 2024,
    region: "日韩",
    rating: 8.2,
    heat: 6120,
    genre: ["爱情", "剧情"],
    actors: ["森川遥", "井上凉", "高桥直人"],
    director: "小林悠",
    duration: "112 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-09-19",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20young%20people%20sitting%20on%20a%20train%20platform%20in%20summer%20heat%20haze%2C%20sunflowers%20and%20electric%20wires%2C%20soft%20warm%20amber%20afternoon%20light%2C%20tender%20romantic%20film%20still%2C%20shallow%20depth%20of%20field%2C%20no%20text&width=400&height=600&seq=tangdou-v004&orientation=portrait",
    tagline: "那个夏天之后，他们都学会了好好告别。",
    description:
      "小镇高中生夏树和转学生凉太在便利店打工时相识。暑假如同一场缓慢退潮的海，把两个人的心事留在沙滩上。即将分别的前夜，他们决定坐上最后一班电车，去看一场还没开始的烟火。",
  },
  {
    id: "v005",
    title: "海岸线以北",
    category: "movie",
    year: 2022,
    region: "内地",
    rating: 7.9,
    heat: 4380,
    genre: ["冒险", "剧情"],
    actors: ["周牧", "许浣", "陈立"],
    director: "高岩",
    duration: "121 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-08-30",
    cover:
      "https://readdy.ai/api/search-image?query=Rugged%20northern%20coastline%20with%20crashing%20waves%20and%20rocky%20cliffs%2C%20a%20hiker%20with%20backpack%20silhouetted%20against%20stormy%20navy%20sky%20and%20amber%20horizon%20light%2C%20cinematic%20adventure%20film%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v005&orientation=portrait",
    tagline: "沿着没有路的北方，他走了一千公里。",
    description:
      "摄影师程野在事业低谷期独自踏上一段北方海岸的徒步旅程。他原本只想拍完最后一组照片，却在沿途遇到修船的老人、开卡车环岛的青年和一只总跟着他的狗。行走成为了一种缓慢的自救。",
  },
  {
    id: "v006",
    title: "雾城追凶",
    category: "movie",
    year: 2025,
    region: "港台",
    rating: 8.7,
    heat: 9410,
    genre: ["犯罪", "悬疑"],
    actors: ["梁家成", "何静琳", "吴少东"],
    director: "潘伟业",
    duration: "126 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-10-05",
    cover:
      "https://readdy.ai/api/search-image?query=Dense%20foggy%20city%20street%20at%20night%20with%20towering%20old%20buildings%20and%20glowing%20amber%20signage%2C%20two%20shadowy%20figures%20facing%20each%20other%2C%20deep%20navy%20shadows%2C%20gritty%20crime%20thriller%20poster%2C%20no%20text&width=400&height=600&seq=tangdou-v006&orientation=portrait",
    tagline: "整座城市都在雾里，只有凶手看得清路。",
    description:
      "连续三起案件的现场都留下同样的一枚旧硬币。即将退休的重案组警司麦克决定私下调查，发现所有线索都指向自己二十年前办错的一桩案子。在雾最浓的那个凌晨，他和真相对面而坐。",
  },
  {
    id: "v007",
    title: "星尘旅人",
    category: "movie",
    year: 2023,
    region: "欧美",
    rating: 8.1,
    heat: 6840,
    genre: ["科幻", "冒险"],
    actors: ["Iris Bell", "Tomas Klein", "Ravi Anand"],
    director: "Nolan Pike",
    duration: "140 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-09-11",
    cover:
      "https://readdy.ai/api/search-image?query=Lone%20traveler%20walking%20across%20an%20alien%20desert%20under%20a%20giant%20ringed%20planet%2C%20deep%20navy%20sky%20with%20warm%20amber%20sand%20glow%2C%20epic%20scale%2C%20cinematic%20science%20fiction%20landscape%2C%20no%20text&width=400&height=600&seq=tangdou-v007&orientation=portrait",
    tagline: "他要穿过整片沙海，只为把一封信送到。",
    description:
      "星际货运员卡尔在沙暴中救下一名失忆的乘客，对方手里攥着一封无法投递的纸质信件。为了弄清收件人的下落，两人驾驶老旧的越野飞船穿越这片被废弃的星球。旅途中，信的内容一点点被读懂。",
  },
  {
    id: "v008",
    title: "我们的春天",
    category: "movie",
    year: 2024,
    region: "内地",
    rating: 8.0,
    heat: 5230,
    genre: ["剧情", "青春"],
    actors: ["苏念", "何嘉树", "罗小满"],
    director: "程青",
    duration: "108 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-09-02",
    cover:
      "https://readdy.ai/api/search-image?query=Nostalgic%20old%20Chinese%20town%20in%20early%20spring%2C%20cherry%20blossoms%20along%20a%20narrow%20brick%20lane%2C%20warm%20amber%20morning%20light%2C%20bicycles%20leaning%20on%20a%20wall%2C%20cinematic%20realistic%20drama%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v008&orientation=portrait",
    tagline: "一间旧书店，四个人的高三与整个春天。",
    description:
      "县城老街上的一间旧书店即将关门，四个常来的高中生决定在毕业前为它办一场告别会。排练、争吵、暗恋和填不完的志愿表，都在那个春天里慢慢发酵，成为很多年后依然会想起的片段。",
  },
  {
    id: "v009",
    title: "无声证词",
    category: "movie",
    year: 2021,
    region: "内地",
    rating: 8.3,
    heat: 5710,
    genre: ["悬疑", "剧情"],
    actors: ["宋亦明", "岑雨", "赵启山"],
    director: "刘海生",
    duration: "117 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-08-21",
    cover:
      "https://readdy.ai/api/search-image?query=Dark%20interrogation%20room%20with%20a%20single%20overhead%20lamp%20casting%20a%20warm%20amber%20circle%20of%20light%20on%20an%20empty%20chair%2C%20deep%20navy%20shadows%2C%20high%20contrast%20cinematic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v009&orientation=portrait",
    tagline: "唯一的目击者，是一个说不出话的孩子。",
    description:
      "一起发生在老居民楼的坠楼案，现场只有一名听障男孩。为了让孩子的证词被法庭采纳，年轻律师与手语翻译一起重新拼凑当天的每个细节。真相的代价，比他们预想的要沉重得多。",
  },
  {
    id: "v010",
    title: "南方来客",
    category: "movie",
    year: 2022,
    region: "内地",
    rating: 7.6,
    heat: 3120,
    genre: ["文艺", "剧情"],
    actors: ["顾南", "阿澜", "老周"],
    director: "吴向晚",
    duration: "102 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-07-30",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20southern%20river%20town%20in%20rain%2C%20narrow%20stone%20bridge%20over%20green%20water%2C%20a%20stranger%20with%20umbrella%20standing%20at%20the%20corner%2C%20muted%20navy%20and%20warm%20ochre%20tones%2C%20arthouse%20film%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v010&orientation=portrait",
    tagline: "他带着一只旧皮箱，在雨里住了整个雨季。",
    description:
      "南方小镇连日阴雨，一位陌生男人租下河边小屋，每天只做两件事：写信和等一个不会来的电话。镇上的人渐渐对他产生好奇，也渐渐各自说出了藏了很久的心事。",
  },
  {
    id: "v011",
    title: "极夜行动",
    category: "movie",
    year: 2025,
    region: "欧美",
    rating: 7.8,
    heat: 7280,
    genre: ["动作", "战争"],
    actors: ["Dmitri Kane", "Sofia Hale", "Owen Park"],
    director: "Greg Molnar",
    duration: "131 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-09-25",
    cover:
      "https://readdy.ai/api/search-image?query=Soldiers%20moving%20through%20a%20snowy%20forest%20at%20polar%20night%2C%20amber%20muzzle%20flash%20against%20deep%20navy%20darkness%2C%20snow%20particles%20in%20the%20air%2C%20cinematic%20action%20film%20still%2C%20dramatic%20lighting%2C%20no%20text&width=400&height=600&seq=tangdou-v011&orientation=portrait",
    tagline: "在没有太阳的四十天里，他们必须完成一次撤离。",
    description:
      "极夜笼罩的边境小镇突然失去联系，一支四人小队被派往执行撤离任务。零下四十度的环境、无法识别的信号和被切断的补给，让这场行动逐渐变成一次关于信任的考验。",
  },
  {
    id: "v012",
    title: "时间旅店",
    category: "movie",
    year: 2026,
    region: "日韩",
    rating: 8.5,
    heat: 8460,
    genre: ["奇幻", "爱情"],
    actors: ["木村绫", "佐藤凉介", "吉冈瞳"],
    director: "大野启",
    duration: "119 分钟",
    episodeCount: 0,
    status: "已完结",
    updatedAt: "2026-10-14",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20vintage%20hotel%20room%20with%20clocks%20covering%20the%20walls%2C%20warm%20amber%20lamp%20glow%2C%20deep%20navy%20night%20beyond%20a%20tall%20window%2C%20cinematic%20fantasy%20film%20still%2C%20dreamlike%20atmosphere%2C%20no%20text&width=400&height=600&seq=tangdou-v012&orientation=portrait",
    tagline: "住进 302 房的人，都能回到最想修改的那一天。",
    description:
      "海边一栋老旧旅店里，据说有一间可以回到过去的房间。女主角为了挽回一场意外住进 302，却发现每次改变都会让另一段记忆消失。当时间开始反过来收取房租，她必须决定要留下什么。",
  },
  {
    id: "v013",
    title: "潮汐之城",
    category: "tv",
    year: 2026,
    region: "内地",
    rating: 9.1,
    heat: 12680,
    genre: ["都市", "悬疑"],
    actors: ["秦岚青", "段奕辰", "许清和"],
    director: "郑书言",
    duration: "单集 45 分钟",
    episodeCount: 24,
    status: "更新至 24 集",
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20coastal%20city%20skyline%20at%20dusk%20with%20a%20lone%20woman%20looking%20out%20over%20the%20harbor%20from%20a%20glass%20tower%2C%20deep%20navy%20blue%20hour%20with%20warm%20amber%20window%20lights%2C%20cinematic%20series%20key%20art%2C%20no%20text&width=400&height=600&seq=tangdou-v013&orientation=portrait",
    tagline: "潮水每晚退去，也每晚带回一件旧事。",
    description:
      "海港城市接连出现游客失踪事件，负责调查的女警发现所有人和十年前的一场台风有关。随着潮汐变化，被掩埋的档案一件件浮出水面。这是一部关于城市记忆、家族秘密与选择代价的都市悬疑剧。",
  },
  {
    id: "v014",
    title: "山河故人录",
    category: "tv",
    year: 2025,
    region: "内地",
    rating: 8.8,
    heat: 10920,
    genre: ["古装", "历史"],
    actors: ["霍长安", "叶知秋", "燕归"],
    director: "沈墨白",
    duration: "单集 48 分钟",
    episodeCount: 36,
    status: "全 36 集",
    updatedAt: "2026-10-10",
    cover:
      "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20general%20in%20dark%20armor%20standing%20on%20a%20mountain%20pass%2C%20banners%20fluttering%20against%20dramatic%20clouds%2C%20deep%20navy%20storm%20sky%20with%20warm%20amber%20light%2C%20epic%20historical%20drama%20key%20art%2C%20no%20text&width=400&height=600&seq=tangdou-v014&orientation=portrait",
    tagline: "守得住一座关，守不住一句诺言。",
    description:
      "边关守将沈砚在战事结束后归京复命，却被卷入朝堂新的权力更迭。旧日的战友站到了对面，家国与私情在他面前被反复称量。全剧以扎实的战争场面和人物群像，讲述一代人的选择。",
  },
  {
    id: "v015",
    title: "白色走廊",
    category: "tv",
    year: 2026,
    region: "内地",
    rating: 8.6,
    heat: 9340,
    genre: ["医疗", "职场"],
    actors: ["温海宁", "路遥", "齐志刚"],
    director: "方可",
    duration: "单集 42 分钟",
    episodeCount: 28,
    status: "更新至 26 集",
    updatedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=Hospital%20corridor%20with%20cool%20white%20walls%20and%20warm%20amber%20light%20spilling%20from%20a%20doorway%2C%20a%20doctor%20in%20scrubs%20seen%20from%20behind%2C%20cinematic%20medical%20drama%20still%2C%20realistic%20detail%2C%20no%20text&width=400&height=600&seq=tangdou-v015&orientation=portrait",
    tagline: "急诊室的灯从没熄过，人也从没停下。",
    description:
      "新任急诊科主任在改革排班制度时，与老资历医生产生了激烈冲突。一部聚焦一线医护日常的群像剧，从每一次抢救、每一场谈话中，呈现专业与人情之间细微的平衡。",
  },
  {
    id: "v016",
    title: "东岸往事",
    category: "tv",
    year: 2024,
    region: "内地",
    rating: 8.4,
    heat: 7520,
    genre: ["年代", "剧情"],
    actors: ["林建国", "周韵华", "何小军"],
    director: "张守正",
    duration: "单集 46 分钟",
    episodeCount: 32,
    status: "全 32 集",
    updatedAt: "2026-09-06",
    cover:
      "https://readdy.ai/api/search-image?query=1980s%20Chinese%20coastal%20town%20street%20with%20old%20shops%20and%20bicycles%2C%20warm%20amber%20sunset%20light%2C%20families%20chatting%20by%20doorways%2C%20nostalgic%20period%20drama%20still%2C%20film%20grain%2C%20no%20text&width=400&height=600&seq=tangdou-v016&orientation=portrait",
    tagline: "一条老街，三代人的柴米与远方。",
    description:
      "改革开放初期的东南沿海小镇，林家三兄妹在父亲留下的修船铺里各自谋生。有人想留下守着家业，有人执意要去外面的世界。时代的风吹进窄窄的巷子，也吹散了又聚拢了这个家。",
  },
  {
    id: "v017",
    title: "第九个嫌疑人",
    category: "tv",
    year: 2025,
    region: "港台",
    rating: 8.9,
    heat: 10340,
    genre: ["刑侦", "悬疑"],
    actors: ["方中信和", "陈敏之", "林子豪"],
    director: "雷振邦",
    duration: "单集 44 分钟",
    episodeCount: 20,
    status: "全 20 集",
    updatedAt: "2026-10-03",
    cover:
      "https://readdy.ai/api/search-image?query=Nine%20empty%20chairs%20lined%20up%20in%20a%20dim%20police%20briefing%20room%2C%20single%20warm%20amber%20lamp%2C%20deep%20navy%20shadows%2C%20tense%20crime%20series%20key%20art%2C%20cinematic%20composition%2C%20no%20text&width=400&height=600&seq=tangdou-v017&orientation=portrait",
    tagline: "八个人都有不在场证明，第九个人没有名字。",
    description:
      "一起密室案的八名相关人士全部通过测谎，案件却在三个月后被重新立案。重案组从一份缺失的笔录入手，发现所有人都默契地省略了同一个人的存在。谁是第九个嫌疑人，成了全剧最大的谜。",
  },
  {
    id: "v018",
    title: "我们的小镇",
    category: "tv",
    year: 2023,
    region: "内地",
    rating: 8.2,
    heat: 5860,
    genre: ["家庭", "治愈"],
    actors: ["宋子禾", "柳青", "王大海"],
    director: "许安然",
    duration: "单集 40 分钟",
    episodeCount: 24,
    status: "全 24 集",
    updatedAt: "2026-08-18",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20town%20evening%20market%20with%20warm%20amber%20lanterns%20and%20steam%20from%20food%20stalls%2C%20people%20chatting%20happily%2C%20cozy%20heartwarming%20scene%2C%20cinematic%20realistic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v018&orientation=portrait",
    tagline: "小镇不大，装得下所有人的鸡毛蒜皮。",
    description:
      "因为一场意外的直播，安静的小镇突然成了网红打卡地。镇上的小饭馆、理发店和快递点被迫迎接汹涌人潮，也迎来了一连串啼笑皆非的故事。一部看完想给家里打电话的温暖剧集。",
  },
  {
    id: "v019",
    title: "摩天之上",
    category: "tv",
    year: 2025,
    region: "内地",
    rating: 7.7,
    heat: 6340,
    genre: ["商战", "都市"],
    actors: ["陆一鸣", "苏婉", "陈天佑"],
    director: "杜衡",
    duration: "单集 43 分钟",
    episodeCount: 30,
    status: "全 30 集",
    updatedAt: "2026-08-27",
    cover:
      "https://readdy.ai/api/search-image?query=Businessman%20silhouette%20looking%20through%20floor%20to%20ceiling%20windows%20at%20a%20night%20city%20skyline%2C%20deep%20navy%20tones%20with%20warm%20amber%20reflections%2C%20sleek%20corporate%20drama%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v019&orientation=portrait",
    tagline: "在最好的楼层，看不见地面上的人。",
    description:
      "年轻的职业经理人被空降接管一家老牌地产公司，面对的是庞大的债务与盘根错节的旧关系。在一次城市更新项目中，他必须在漂亮的财报和一整片老社区的命运之间作出选择。",
  },
  {
    id: "v020",
    title: "夜色温柔",
    category: "tv",
    year: 2026,
    region: "日韩",
    rating: 8.3,
    heat: 8130,
    genre: ["爱情", "都市"],
    actors: ["韩素妍", "李道贤", "郑雨琳"],
    director: "朴智恩",
    duration: "单集 41 分钟",
    episodeCount: 16,
    status: "更新至 14 集",
    updatedAt: "2026-10-13",
    cover:
      "https://readdy.ai/api/search-image?query=Couple%20standing%20on%20a%20rooftop%20overlooking%20city%20lights%20at%20night%2C%20warm%20amber%20bokeh%20lights%2C%20deep%20navy%20sky%2C%20romantic%20cinematic%20series%20still%2C%20soft%20focus%2C%20no%20text&width=400&height=600&seq=tangdou-v020&orientation=portrait",
    tagline: "两个人的作息，刚好错开了整个白天。",
    description:
      "夜班电台主持人和急诊科医生在同一个城市的两个时区里生活。他们通过深夜节目结识，却总在对方睡着时醒来。这部温柔的城市爱情剧，讲述如何在一座不眠的城市里，找到同频的人。",
  },
  {
    id: "v021",
    title: "边境线",
    category: "tv",
    year: 2024,
    region: "内地",
    rating: 8.7,
    heat: 9640,
    genre: ["谍战", "悬疑"],
    actors: ["程实", "沐云", "罗北"],
    director: "关志远",
    duration: "单集 45 分钟",
    episodeCount: 24,
    status: "全 24 集",
    updatedAt: "2026-09-16",
    cover:
      "https://readdy.ai/api/search-image?query=Two%20figures%20exchanging%20a%20briefcase%20at%20a%20snowy%20border%20train%20station%2C%20vintage%20train%20and%20steam%2C%20deep%20navy%20winter%20dusk%20with%20warm%20amber%20station%20lamps%2C%20spy%20thriller%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v021&orientation=portrait",
    tagline: "在两条国境线之间，没有一处是安全的。",
    description:
      "上世纪三十年代的边境小站，一名铁路调度员同时被两方势力招募。他每天用列车的时刻表传递情报，也每天在想离场的理由。当一份名单即将被送出境，他必须做出唯一一次不为自己考虑的决定。",
  },
  {
    id: "v022",
    title: "料理人的四季",
    category: "tv",
    year: 2022,
    region: "日韩",
    rating: 8.5,
    heat: 4980,
    genre: ["剧情", "美食"],
    actors: ["坂本悠", "伊藤春", "小野寺真"],
    director: "内田和也",
    duration: "单集 38 分钟",
    episodeCount: 20,
    status: "全 20 集",
    updatedAt: "2026-07-22",
    cover:
      "https://readdy.ai/api/search-image?query=Japanese%20kitchen%20in%20autumn%20with%20a%20chef%20plating%20a%20seasonal%20dish%2C%20warm%20amber%20light%20through%20wooden%20lattice%20window%2C%20steam%20and%20fresh%20ingredients%2C%20cinematic%20food%20drama%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v022&orientation=portrait",
    tagline: "四季轮流上桌，日子就不算白过。",
    description:
      "东京一家只做时令菜的小食堂，主厨每天只准备一份菜单。从春天的笋到冬天的萝卜，客人的故事随着季节更替在这里发生。剧集用大量真实料理镜头，记录一间小店的春夏秋冬。",
  },
  {
    id: "v023",
    title: "一起出发吧 第五季",
    category: "variety",
    year: 2026,
    region: "内地",
    rating: 8.4,
    heat: 11280,
    genre: ["户外", "真人秀"],
    actors: ["嘉宾团：陆星野、许知夏、陈小满、阿川"],
    director: "总导演 何一鸣",
    duration: "单期 95 分钟",
    episodeCount: 12,
    status: "更新至 第 9 期",
    updatedAt: "2026-10-16",
    cover:
      "https://readdy.ai/api/search-image?query=Group%20of%20young%20travelers%20with%20backpacks%20laughing%20on%20a%20mountain%20road%20at%20sunrise%2C%20warm%20amber%20sunlight%2C%20deep%20navy%20mountain%20silhouettes%2C%20energetic%20reality%20show%20key%20art%2C%20no%20text&width=400&height=600&seq=tangdou-v023&orientation=portrait",
    tagline: "这一次，没有剧本，只有路和风。",
    description:
      "第五季升级为无路书旅行，嘉宾只拿到一张手绘地图和一个目的地关键词。他们需要自己搭车、找住宿、解决三餐，在路上遇见真实的风景与陌生人。每周五更新，陪你从城市走去山野。",
  },
  {
    id: "v024",
    title: "声音的力量",
    category: "variety",
    year: 2026,
    region: "内地",
    rating: 8.7,
    heat: 10560,
    genre: ["音乐", "竞技"],
    actors: ["导师阵容：林哲、苏芩、周牧野"],
    director: "总导演 陈斯年",
    duration: "单期 105 分钟",
    episodeCount: 14,
    status: "更新至 第 10 期",
    updatedAt: "2026-10-15",
    cover:
      "https://readdy.ai/api/search-image?query=Contemporary%20concert%20stage%20with%20dramatic%20spotlights%2C%20singer%20silhouette%20haloed%20by%20warm%20amber%20beams%20against%20deep%20navy%20darkness%2C%20cinematic%20music%20show%20key%20art%2C%20no%20text&width=400&height=600&seq=tangdou-v024&orientation=portrait",
    tagline: "没有伴奏，没有修音，只有一把嗓子。",
    description:
      "原创音乐竞演节目，选手以现场乐队伴奏完成整季演出。每一期围绕一个主题重新编曲，导师只提供建议不参与投票，最终成绩完全由现场观众决定。节目同时记录创作幕后与彩排过程。",
  },
  {
    id: "v025",
    title: "深夜食堂客厅",
    category: "variety",
    year: 2025,
    region: "内地",
    rating: 8.1,
    heat: 6870,
    genre: ["生活", "访谈"],
    actors: ["主持：白露、老谢"],
    director: "总导演 顾南亭",
    duration: "单期 60 分钟",
    episodeCount: 16,
    status: "全 16 期",
    updatedAt: "2026-09-08",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20late%20night%20living%20room%20set%20with%20warm%20amber%20lamps%2C%20comfortable%20sofas%20and%20a%20small%20kitchen%20counter%2C%20intimate%20talk%20show%20atmosphere%2C%20cinematic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v025&orientation=portrait",
    tagline: "深夜十二点，客厅的门为聊天的人开着。",
    description:
      "一档在真实客厅里录制的深夜访谈节目，每期只请一位客人。没有固定问题，也没有台本，嘉宾一边做饭一边聊最近的生活。适合在睡前慢慢看完的那一类节目。",
  },
  {
    id: "v026",
    title: "舞台正中央",
    category: "variety",
    year: 2025,
    region: "内地",
    rating: 8.5,
    heat: 8890,
    genre: ["舞蹈", "竞技"],
    actors: ["导师：沈竹、Mia、阿KEN"],
    director: "总导演 韦宁",
    duration: "单期 90 分钟",
    episodeCount: 12,
    status: "全 12 期",
    updatedAt: "2026-09-30",
    cover:
      "https://readdy.ai/api/search-image?query=Dancer%20in%20motion%20on%20a%20grand%20theater%20stage%2C%20flowing%20fabric%20caught%20mid%20spin%2C%20warm%20amber%20spotlight%20against%20deep%20navy%20backdrop%2C%20dynamic%20cinematic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v026&orientation=portrait",
    tagline: "灯亮起的三分钟，没有人能替你跳。",
    description:
      "面向素人舞者的竞技节目，涵盖街舞、现代舞、民族舞等多种风格。每期进行限时编舞挑战，选手需要与不同搭档完成磨合。节目完整呈现排练过程与舞台呈现，看得见汗水的竞技。",
  },
  {
    id: "v027",
    title: "出发去露营",
    category: "variety",
    year: 2024,
    region: "内地",
    rating: 8.0,
    heat: 5420,
    genre: ["户外", "治愈"],
    actors: ["常驻：周末、小鹿、阿远"],
    director: "总导演 苏木",
    duration: "单期 75 分钟",
    episodeCount: 10,
    status: "全 10 期",
    updatedAt: "2026-08-12",
    cover:
      "https://readdy.ai/api/search-image?query=Camping%20tent%20glowing%20with%20warm%20amber%20light%20under%20a%20starry%20deep%20navy%20sky%2C%20lakeside%20at%20night%2C%20friends%20around%20a%20small%20campfire%2C%20cozy%20cinematic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v027&orientation=portrait",
    tagline: "把周末交给山和湖，信号交给风。",
    description:
      "三位主持人每期挑选一个两小时车程内的营地，从搭帐篷开始记录完整的露营过程。节目不追求难度，只分享装备经验、野外做饭和看星星的乐趣，适合刚入门的新手参考。",
  },
  {
    id: "v028",
    title: "笑场研究所",
    category: "variety",
    year: 2026,
    region: "内地",
    rating: 8.6,
    heat: 9180,
    genre: ["喜剧", "脱口秀"],
    actors: ["常驻：老贾、陈可乐、五月"],
    director: "总导演 罗宇",
    duration: "单期 80 分钟",
    episodeCount: 12,
    status: "更新至 第 8 期",
    updatedAt: "2026-10-11",
    cover:
      "https://readdy.ai/api/search-image?query=Stand%20up%20comedy%20club%20stage%20with%20a%20microphone%20stand%2C%20warm%20amber%20spotlight%20on%20a%20brick%20wall%2C%20audience%20silhouettes%20in%20foreground%2C%20cinematic%20comedy%20show%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v028&orientation=portrait",
    tagline: "所有说不出口的事，都能在这里笑出来。",
    description:
      "每期围绕一个生活话题，由六位喜剧人完成原创段子演出，并接受现场观众的即时投票。节目保留了完整的开放麦氛围，也会放出被剪掉的冷场片段，真实感拉满。",
  },
  {
    id: "v029",
    title: "好奇心实验室",
    category: "variety",
    year: 2023,
    region: "内地",
    rating: 7.9,
    heat: 3670,
    genre: ["科普", "纪实"],
    actors: ["主持：方教授、阿豆"],
    director: "总导演 沈一",
    duration: "单期 45 分钟",
    episodeCount: 18,
    status: "全 18 期",
    updatedAt: "2026-07-15",
    cover:
      "https://readdy.ai/api/search-image?query=Mysterious%20science%20laboratory%20with%20glass%20beakers%20and%20floating%20dust%20in%20warm%20amber%20light%20beams%2C%20deep%20navy%20shadows%2C%20documentary%20style%20cinematic%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v029&orientation=portrait",
    tagline: "把生活里的小疑问，做成一次正经实验。",
    description:
      "科普纪实节目，每期用一个可复现的实验回答一个日常问题：为什么雨后的空气更好闻，冰箱里的面包为什么会变硬。节目与高校实验室合作拍摄，用通俗的方式呈现科学方法。",
  },
  {
    id: "v030",
    title: "城市漫游计划",
    category: "variety",
    year: 2026,
    region: "内地",
    rating: 8.2,
    heat: 7140,
    genre: ["旅行", "文化"],
    actors: ["主持：林一白、夏至"],
    director: "总导演 叶青",
    duration: "单期 70 分钟",
    episodeCount: 12,
    status: "更新至 第 7 期",
    updatedAt: "2026-10-09",
    cover:
      "https://readdy.ai/api/search-image?query=Wanderer%20walking%20through%20old%20city%20alleys%20at%20dusk%2C%20warm%20amber%20shop%20lights%20and%20wet%20stone%20pavement%2C%20deep%20navy%20evening%20sky%2C%20cinematic%20travel%20documentary%20still%2C%20no%20text&width=400&height=600&seq=tangdou-v030&orientation=portrait",
    tagline: "不打卡景点，只走本地人常走的路。",
    description:
      "两位主持人每期用一整天时间步行穿过一座城市的老城区，从早餐摊走到夜宵店，拜访手艺人、老店主和街坊。没有攻略清单，只有一条慢慢走出来的路线。",
  },
];